import { Component } from "@angular/core";
import { Router, NavigationStart } from "@angular/router";
import { RouteMonitor } from "@nordpoolgroup/nps-angular-2-common";

@Component({
    selector: "nps-root",
    template: require("./appComponent.html")
})
export class AppComponent {
    title = "nps";

    constructor(
        public routeMonitor: RouteMonitor,
        public router: Router
    ) {
        this.router.events.subscribe(event => {
            // Change format of oauthcallback url to url with query params
            // so that @angular/router can process
            if (event instanceof NavigationStart) {
                this.routeMonitor.oauthUrlCheck(event.url);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/AppComponent.ts